import {createLogger} from '@servicenow/ui-internal';

export default createLogger({
	module: '@servicenow/ui-core'
});
